"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPopup = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledPopup = styled_components_1.default.div.withConfig({
    shouldForwardProp: (prop) => !["alignH", "alignV"].includes(prop),
}) `
  // max-width: 30vw;
  // max-height: 50vh;
  box-sizing: border-box;
  position: absolute;

  ${({ alignH, alignV }) => {
    let transform;
    switch (alignH) {
        case "left":
            transform = `translateX(-100%)`;
            break;
        case "center":
            transform = `translateX(-50%)`;
            break;
    }
    switch (alignV) {
        case "top":
            transform = `${transform || ""} translateY(-100%)`;
            break;
        case "middle":
            transform = `${transform || ""} translateY(-50%)`;
            break;
    }
    return (0, styled_components_1.css) `
      ${transform && `transform: ${transform};`}
    `;
}}
`;
//# sourceMappingURL=styled.js.map